import { FunctionComponent, useRef, useState } from "react";
import Modal from "react-modal";
import styles from "../ListViewModal/ListViewModal.module.css";
import Loading from "../../Loading/Loading";
import TextInput from "../../TextInput/TextInput";
import { connect, useDispatch } from "react-redux";
import Dropdown from "../../DropDown/Dropdown";
import { showSnackbarAction } from "../../../Redux/actions";
import { createCustomButton } from "../../../Services/organizations";

/* ------------------------------------------------------------------
   TYPES
-------------------------------------------------------------------*/
type props = {
  open: boolean;
  close: () => void;
  organizationId: any;
};

/* ------------------------------------------------------------------
   MAIN COMPONENT
-------------------------------------------------------------------*/
const AddCustomButtonModal: FunctionComponent<props> = ({
  organizationId,
  open,
  close,
}) => {
  const dispatcher = useDispatch();
  const urlRef: any = useRef();
  const nameRef: any = useRef();
  const parameterRef: any = useRef();
  const headerRef: any = useRef();

  /** Loader state */
  const [load, setLoad] = useState(false);

  /** Selected request type (post / get) */
  const [type, setType] = useState("");

  /** Dropdown options */
  const typeOptions = ["POST", "GET"];

  /* ------------------------------------------------------------------
    VALIDATION + SAVE HANDLER
    - Prevents saving until ALL required fields are filled
    - Parses stringified parameters and headers
    - Calls backend service createCustomButton()
 -------------------------------------------------------------------*/
  const onSave = () => {
    if (nameRef.current.value === "") {
      dispatcher(
        showSnackbarAction(
          "Please Enter Button Name!!",
          "error"
        )
      );
    } else if (urlRef.current.value === "") {
      dispatcher(
        showSnackbarAction(
          "Please Enter URL Link!!",
          "error"
        )
      );
    } else if (type === "") {
      dispatcher(
        showSnackbarAction("Please Enter Type!!", "error")
      );
    } else {

      /** STEP 1: Parse parameters (JSON) */
      const para = JSON.parse(
        parameterRef.current.value
      ).reduce((obj: any, item: any) => Object.assign(obj, { [item.key]: item.value }),
        {}
      );

      /** STEP 2: Parse headers (JSON) */
      const head = headerRef.current.value !== "" ? JSON.parse(headerRef.current.value) : undefined;

      /** STEP 3: Trigger API */
      setLoad(true);
      createCustomButton(
        organizationId,
        nameRef.current.value,
        urlRef.current.value,
        para,
        head,
        type,
        setLoad,
        dispatcher,
        close
      );
    }
  };
  return (
    <Modal
      isOpen={open}
      className={styles.parent}
      shouldCloseOnOverlayClick={true}
      overlayClassName={styles.overlay}
      shouldCloseOnEsc={true}
      onRequestClose={close}
    >
      {/* FULLSCREEN LOADING OVERLAY */}
      {load && <Loading />}

      {/* ------------------------------ */}
      {/* TITLE */}
      {/* ------------------------------ */}
      <div className={styles.headingContainer}>
        <p className={styles.heading}>Add Custom Button</p>
      </div>

      {/* ------------------------------ */}
      {/* INPUT FIELDS */}
      {/* ------------------------------ */}
      <div className={styles.profileContainer}>

        {/* Button Name */}
        <p className={styles.profile}>Button Name</p>
        <TextInput
          title={"Enter Button Name"}
          ref={nameRef}
          disabled={false}
        />

        {/* URL */}
        <p className={styles.profile} style={{ marginTop: "25px" }}> Enter URL</p>
        <TextInput
          title={"Enter URL"}
          ref={urlRef}
          disabled={false}
        />

        {/* Parameters */}
        <p className={styles.profile} style={{ marginTop: "25px" }} >Enter URL Parameters  </p>
        <TextInput
          title={
            'Enter URL Parameter ( format - [{"key","value"}, {"key", "value"}] )'
          }
          ref={parameterRef}
          disabled={false}
        />

        {/* Headers */}
        <p className={styles.profile} style={{ marginTop: "25px" }}>Enter URL Headers</p>
        <TextInput
          title={"Enter URL Headers"}
          ref={headerRef}
          disabled={false}
        />

        {/* Select Type */}
        <p className={styles.profile} style={{ marginTop: "25px" }}>Select Type</p>
        <Dropdown
          option={typeOptions}
          setSelectedValue={(val) =>
            setType(val.value.toLowerCase())
          }
        />
      </div>

      {/* ------------------------------ */}
      {/* BUTTONS */}
      {/* ------------------------------ */}
      <div className={styles.buttonView} style={{ marginTop: "25px" }}>
        <button className={styles.cancelButton} onClick={close}>
          Cancel
        </button>
        <button className={styles.saveButton} onClick={onSave}>
          Save
        </button>
      </div>
    </Modal>
  );
};

/* ------------------------------------------------------------------
   REDUX CONNECTION
-------------------------------------------------------------------*/
const mapStateToProps = (state: any) => {
  return {
    organizationId: state.organization.id,
  };
};

export default connect(mapStateToProps)(
  AddCustomButtonModal
);
